import { Lock } from "lucide-react";
import { T } from "@/locales/tr";

// Mention de paiement unique pour tout le site (compte Stripe Papicoo commun, ventes en ligne fermées)
export function PaymentNotice({ className = "" }) {
  return (
    <p data-testid="payment-notice" className={`flex items-start gap-2 text-xs text-[color:var(--papicoo-muted)] ${className}`}>
      <Lock size={13} className="shrink-0 mt-0.5 text-[color:var(--papicoo-gold)]" />
      <span>{T("Paiement sécurisé par Stripe (compte Papicoo unique). Les paiements en ligne sont fermés pour le moment ; les achats déjà réglés restent honorés.")}</span>
    </p>
  );
}
